import { Box, styled, Typography, useTheme } from '@mui/material';
import NoResultsFound from 'assets/no-results-found.png';
import { Modal } from 'sharedComponents/Modal/Modal';
import { PrimaryButton } from 'sharedComponents/Buttons/PrimaryButton';
import { SecondaryButton } from 'sharedComponents/Buttons/SecondaryButton';
import { ConnectPreferencesFormDataTestIds } from '../../../../../data-testids/ConnectDataTestIds';
import { NoJobsFoundModalProps } from '../../../../../types/connectTypes';

const NoJobsFoundModal = ({ onClose, onSubmit }: NoJobsFoundModalProps) => {
  const theme = useTheme();

  return (
    <Modal
      title="Are you sure you want to continue?"
      open
      onClose={onClose}
      ctaButtons={
        <CTAButtons>
          <SecondaryButton
            size="large"
            color="black"
            onClick={onClose}
            dataTestId={ConnectPreferencesFormDataTestIds.NO_JOBS_FOUND_CLOSE_BUTTON}
          >
            Update my preferences
          </SecondaryButton>
          <PrimaryButton
            size="large"
            onClick={onSubmit}
            dataTestId={ConnectPreferencesFormDataTestIds.NO_JOBS_FOUND_CONTINUE_BUTTON}
          >
            Continue
          </PrimaryButton>
        </CTAButtons>
      }
      borderRadius={theme.shape.borderRadius}
    >
      <Typography variant="body1">
        We didn&apos;t find any job openings that match your preferences. Try adjusting your
        preferred location, subjects, or grades.
      </Typography>
      <StyledImageBox>
        <NoResultsFoundImage src={NoResultsFound} alt="No results found" />
      </StyledImageBox>
    </Modal>
  );
};

const CTAButtons = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

const StyledImageBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#F7F7F6',
  padding: theme.spacing(2),
  margin: `${theme.spacing(4)} 0`,
  transform: 'scaleX(-1)',
  borderRadius: `${theme.shape.borderRadius * 4}px`,
}));

const NoResultsFoundImage = styled('img')(() => ({
  width: '125px',
  height: '125px',
  margin: `0 auto`,
  display: 'block',
  opacity: '50%',
}));

export default NoJobsFoundModal;
